var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("위치안내")])]), _c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section pb-0"
  }, [_c('div', [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3161.194505723795!2d126.96008095117394!3d37.59758107969291!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2ad006e6f8f%3A0x2d94339bb0d25ba3!2z7ISc7Jq47Yq567OE7IucIOyiheuhnOq1rCDsnpDtlZjrrLjroZw0Meq4uCA0!5e0!3m2!1sko!2skr!4v1651548005187!5m2!1sko!2skr",
      "width": "100%",
      "height": "500",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('div', {
    staticClass: "pt-24 pb-34 pt-md-34 pb-md-44"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7"
    }
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "font-size-16 font-weight-bold primary--text"
  }, [_vm._v("ADDRESS")]), _c('p', {
    staticClass: "font-size-18 font-size-md-22"
  }, [_vm._v("서울특별시 종로구 자하문로41길 4 (서울특별시 종로구 부암동 185-6)")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "font-size-16 font-weight-bold primary--text"
  }, [_vm._v("TEL")]), _c('p', {
    staticClass: "font-size-18 font-size-md-22"
  }, [_vm._v("02) 395-6987")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "3"
    }
  }, [_c('div', {
    staticClass: "page-text"
  }, [_c('p', {
    staticClass: "font-size-16 font-weight-bold primary--text"
  }, [_vm._v("MAIL")]), _c('p', {
    staticClass: "font-size-18 font-size-md-22"
  }, [_vm._v("contact@kataauction.com")])])])], 1)], 1)]), _c('v-divider', {
    staticClass: "primary border-2"
  }), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10"
  }, [_c('h4', {
    staticClass: "tit tit--xs"
  }, [_vm._v("오시는 길")])]), _c('div', [_c('div', {
    staticClass: "table-scroll"
  }, [_c('div', {
    staticClass: "table-scroll__inner"
  }, [_c('v-simple-table', {
    staticClass: "v-simple-table v-data-table--none-active-bg v-data-table--default v-data-table--none-border-left",
    staticStyle: {
      "min-width": "768px"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("버스")]), _c('td', [_c('div', {
    staticClass: "page-text pa-16 px-md-30 py-md-20"
  }, [_c('p', [_vm._v("하림각 정류장")]), _c('p', [_vm._v("1020, 1711, 7016, 7018, 7022, 7212, 8002번 ")])])])]), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("지하철")]), _c('td', [_c('div', {
    staticClass: "page-text pa-16 px-md-30 py-md-20"
  }, [_c('p', [_vm._v("3호선 경복궁역 3번 출구 → 버스 1020, 1711, 7016, 7018, 7022, 7212, 8002번 환승 → 하림각 정류장 하차")]), _c('p', [_vm._v("5호선 광화문역 2번 출구 → 버스 1020, 1711, 7016, 7018, 7212번 환승 → 하림각 정류장 하차")])])])]), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("자동차")]), _c('td', [_c('div', {
    staticClass: "page-text pa-16 px-md-30 py-md-20"
  }, [_c('p', [_vm._v("경복궁역에서 경복고등학교 방향으로 직진 → 자하문 터널 → HW컨벤션센터(하림각) 앞 사거리에서 좌회전 → 30m 전방 우측 캐터옥션")]), _c('p', [_vm._v("＊ 내부순환로(성산) 방면 → 국민대입구에서 북악터널 방면으로 도시고속도로 출구→세검정에서 광화문 방면으로 좌회전 → 하림각 앞 사거리에서 우회전 → 30m 전방 우측 캐터옥션")])])])])])])], 1)])])])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }